import { colors } from "@styles/colors";

const containerStyle = {
  width: "100%",
  height: "100%",
  maxWidth: "100%",
};

const wh100 = {
  flex: 1,
  width: "100%",
  height: "100%",
  maxWidth: "100%",
  maxHeight: "100%",
};

const center = {
  alignItems: "center",
  justifyContent: "center",
};

const btnShareStyle = {
  mx: "$4.5",
  size: "$5",
  backgroundColor: "#FFF",
  color: colors.btnBlue,
  borderRadius: "$3",
};

const ShareBlueButton = {
  bg: colors.btnBlue,
  color: "#FFF",
  fontSize: "$5",
  fontWeight: "bold",
  py: "$5",
  borderRadius: "$3",
};

const ShareWhiteButton = {
  bg: "#FFF",
  borderColor: colors.btnBlue,
  borderRadius: "$3",
  borderWidth: 1,
  color: colors.btnBlue,
  fontSize: "$5",
  fontWeight: "bold",
  py: "$5",
};

const iconButtonStyle = {
  padding: "$2.5",
  borderWidth: 0,
  borderRadius: "$3",
};

const shadow = {
  boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.25)",
};

const pageMargin = {
  register: "$5",
  home: "$4",
};

export {
  containerStyle,
  wh100,
  center,
  btnShareStyle,
  shadow,
  ShareBlueButton,
  ShareWhiteButton,
  pageMargin,
  iconButtonStyle,
};
